module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/big_image@2x.a17ee50.jpg";